import React from 'react'

// General Layouts
import Home from 'layouts/Home'
import Login from 'layouts/Login'
import Logout from 'layouts/Logout'
import PasswordReset from 'layouts/PasswordReset'
import Callback from 'layouts/Callback'
import NotFound from 'layouts/NotFound'

// Surety Layouts
import Dashboard from 'layouts/Dashboard'
import OnBoarding from 'layouts/OnBoarding'
import Inventory from 'layouts/Inventory'
import Settings from 'layouts/Settings'
import Receipt from 'layouts/Receipt'
import StatusDownload from 'layouts/StatusDownload'
import TransferPostingAgency from 'layouts/TransferPostingAgency'
import PowerProofUpload from 'layouts/PowerProofUpload'
import VerifyPowerCode from 'layouts/VerifyPowerCode'

const GENERAL_PATHS = [
  {
    path: '/',
    element: <Home />
  },
  {
    path: '/login',
    element: <Login />
  },
  {
    path: '/logout',
    element: <Logout />
  },
  {
    path: '/reset/:token',
    element: <PasswordReset />
  },
  {
    path: '/signup/:token',
    element: <PasswordReset />
  },
  {
    path: '/callback',
    element: <Callback />
  },
  {
    path: '/404',
    element: <NotFound />,
    isPrivate: false
  }
]

const PATHS = [
  {
    path: '/receipt',
    exact: true,
    element: <Receipt />
  },
  {
    path: '/download/:downloadId',
    exact: true,
    element: <StatusDownload />
  },
  {
    path: '/report/:reportId/power-proofs',
    exact: true,
    element: <PowerProofUpload />
  },
  {
    path: '/transfer/:transferId',
    exact: true,
    element: <TransferPostingAgency />
  },
  {
    path: '/p/:powerId',
    exact: true,
    element: <VerifyPowerCode />
  },
  {
    path: '/dashboard',
    exact: true,
    element: <Dashboard />,
    isPrivate: true
  },
  {
    path: '/onboarding',
    exact: true,
    element: <OnBoarding />,
    isPrivate: true
  },
  {
    path: '/onboarding/information',
    exact: true,
    element: <OnBoarding />,
    isPrivate: true
  },
  {
    path: '/onboarding/uploads',
    exact: true,
    element: <OnBoarding />,
    isPrivate: true
  },
  {
    path: '/onboarding/sign',
    exact: true,
    element: <OnBoarding />,
    isPrivate: true
  },
  {
    path: '/onboarding/sign/contract',
    exact: true,
    element: <OnBoarding />,
    isPrivate: true
  },
  {
    path: '/inventory',
    exact: true,
    element: <Inventory />,
    isPrivate: true
  },
  {
    path: '/inventory/power-packs',
    exact: true,
    element: <Inventory />,
    isPrivate: true
  },
  {
    path: '/inventory/powers',
    exact: true,
    element: <Inventory />,
    isPrivate: true
  },
  {
    path: '/inventory/reports',
    exact: true,
    element: <Inventory />,
    isPrivate: true
  },
  {
    path: '/inventory/report/:reportId',
    exact: true,
    element: <Inventory />,
    isPrivate: true
  },
  {
    path: '/inventory/report/add',
    exact: true,
    element: <Inventory />,
    isPrivate: true
  },
  {
    path: '/settings',
    exact: true,
    element: <Settings />,
    isPrivate: true
  },
  {
    path: '/settings/employees',
    exact: true,
    element: <Settings />,
    isPrivate: true
  },
  {
    path: '/settings/permissions',
    exact: true,
    element: <Settings />,
    isPrivate: true
  }
]

const getPaths = () => {
  return [...GENERAL_PATHS, ...PATHS]
}

export default getPaths()